export const copy = {
  brand: '보낼연주',
  workingLabel: '원본 영상은 이 기기에만',
  navigation: {
    home: '지원 현황',
    preparation: '준비 순서',
    rules: '요강 확인',
    takes: '영상 선택',
    timeline: '촬영 기록',
    preflight: '최종 점검',
    receipt: '제출 기록',
  },
  landing: {
    category: '오디션·콩쿠르 영상 즉시 검사',
    headline: '보낼 영상, 먼저 골라보세요. 파일 상태부터 바로 확인해요.',
    subhead: '영상 하나를 고르면 형식·용량·길이·화면 크기를 이 기기에서 읽어요. 요강 문장을 붙여 넣으면 제한 후보를 찾아 내 영상과 대조해요.',
    primaryAction: '영상 하나 고르고 바로 검사',
    sampleAction: '샘플로 확인 과정 보기',
    steps: [
      { title: '영상 하나 고르기', description: '원본은 업로드하지 않고 이 기기에서만 읽어요.' },
      { title: '요강 문장 확인하기', description: '붙여 넣은 문장에서 제한 후보를 찾아요.' },
      { title: '고칠 것 바로 보기', description: '맞음·수정 필요·직접 확인으로 나눠 보여 줘요.' },
    ],
  },
  guide: {
    category: '오디션·콩쿠르 영상 제출 체크리스트',
    headline: '연주 영상을 보내기 전, 이 7가지는 꼭 확인하세요.',
    subhead: '파일 형식과 촬영 규칙은 지원처마다 달라요. 아래 항목을 공식 요강에서 찾고, 내 영상과 하나씩 대조하면 제출 직전의 누락을 줄일 수 있어요.',
    items: [
      { title: '공식 요강과 마감 시각', description: '공식 페이지 주소, 마지막 확인 날짜, 마감 시간대를 함께 남겨요.' },
      { title: '곡·악장·연주 순서', description: '지원서에 적은 곡과 영상의 곡·악장 순서가 같은지 확인해요.' },
      { title: '촬영과 편집 규칙', description: '원테이크, 화면 구도, 소개 멘트, 편집 허용 여부를 요강 문구 그대로 확인해요.' },
      { title: '파일 형식·용량·길이', description: 'MP4처럼 보이는 이름만 믿지 말고 실제 파일 정보와 요강의 제한을 대조해요.' },
      { title: '파일명과 제출 방식', description: '이름·수험번호 표기, 영문 파일명, 직접 업로드 또는 영상 링크 여부를 확인해요.' },
      { title: '처음부터 끝까지 재생', description: '소리와 화면이 맞는지, 시작과 끝이 잘리지 않았는지 전체를 재생해 봐요.' },
      { title: '지원처 미리보기와 접수 기록', description: '지원처 화면에서 다시 재생하고, 접수번호나 완료 화면은 별도로 남겨요.' },
    ],
    primaryAction: '내 지원 확인 시작하기',
    sampleAction: '샘플로 30초 확인하기',
  },
  privacyPromise: '원본 영상은 이 기기에만 저장돼요.',
  currentAccess: {
    label: '현재 이용 상태',
    headline: '첫 지원의 안전 기능은 계속 무료예요.',
    description: '여러 지원을 함께 관리하는 기능도 현재는 무료예요. 실제 결제는 받지 않아요. 예정 가격과 무료 범위는 설정에서 볼 수 있어요.',
  },
  noScore: '연주 수준을 평가하지 않아요. 어떤 영상을 보낼지는 연주자가 직접 정해요.',
  terms: {
    program: '지원',
    take: '연주 영상',
    finalLock: '보낼 영상으로 정하기',
    fileIdentity: '파일 확인 코드',
    manualCheck: '직접 재생 확인',
    receipt: '제출 확인 기록',
    proof: '제출 완료 내용',
    handoff: '제출 준비 내용',
  },
  takeTimeline: {
    headline: '촬영한 영상마다 달라진 점을 나란히 확인하세요.',
    description: '촬영 순서, 파일 점검 결과, 내가 이 영상을 남긴 이유를 함께 봐요. 영상이 두 개 이상이면 한 장씩 넘기며 다음 촬영에서 바꿀 점을 적을 수 있어요.',
    mediaMissing: '원본이 이 기기에 없어요',
    mediaError: '기기에 저장한 영상을 열지 못했어요',
    safety: '얼굴을 인식하거나 외모·연주 수준을 평가하지 않아요. 원본 영상은 기기 밖으로 보내지 않고, 지원 결과도 사용자가 직접 확인한 내용만 기록해요.',
  },
  settings: {
    deleteSuccess: '이 기기의 자료를 모두 삭제했어요.',
    deleteFailure: '삭제 완료를 확인하지 못했어요. 화면의 기록은 그대로 두었어요. 다른 탭에서 이 서비스를 닫고 다시 시도해 주세요.',
  },
};

export const verdictLabels = {pass: '통과', check: '확인 필요', fail: '수정 필요'} as const;
export function videoCodecLabel(codec?: string) {
  return codec ? ({avc1:'H.264',avc3:'H.264',h264:'H.264',hvc1:'HEVC (H.265)',hev1:'HEVC (H.265)',hevc:'HEVC (H.265)',apcn:'Apple ProRes',apch:'Apple ProRes',ap4h:'Apple ProRes'} as Record<string,string>)[codec] ?? '알 수 없는 재생 방식' : '확인 필요';
}
